import type { AlertProps } from '@/core/components/Alert/Alert';
import Alert from '@/core/components/Alert/Alert';

export type { AlertProps };
export default Alert;
